import * as React from 'react';

import { Icon, IconColor, IconName } from 'common/components/controls';
import {
  Button,
  ButtonTypes,
  PrimaryButton,
} from 'common/components/controls/button/button';
import { forNamespace } from 'common/lib/util/i18n';
import InlineLink from '../billable-guests-alert/inline-link';
import styles from './notice-banner.less';

interface NoticeBannerProps {
  children: React.ReactNode;
  inline?: boolean;
  learnMoreUrl?: string;
  actionButton?: {
    text: string;
    onClick: () => void;
  };
  onDismiss?: () => void;
}

const learnMore = forNamespace()('learn more button');

const NoticeBanner = ({
  children,
  inline,
  onDismiss,
  actionButton,
  learnMoreUrl,
}: NoticeBannerProps) => {
  return (
    <div className={`${styles.bannerContainer} ${inline && styles.inline}`}>
      <div className={styles.textContent}>
        {children}{' '}
        {learnMoreUrl &&
          inline && <InlineLink text={learnMore} href={learnMoreUrl} />}
      </div>
      {learnMoreUrl &&
        !inline && (
          <div className={styles.learnMoreButton}>
            <Button
              onClick={() => window.open(learnMoreUrl, '_blank')}
              type={ButtonTypes.LINKBUTTON}
              role="link"
            >
              {learnMore}
            </Button>
          </div>
        )}
      {actionButton &&
        !inline &&
        !learnMoreUrl && (
          <div className={styles.learnMoreButton}>
            <PrimaryButton onClick={actionButton.onClick} role="link">
              {actionButton.text}
            </PrimaryButton>
          </div>
        )}
      {onDismiss && (
        <div className={styles.closeButton} onClick={onDismiss} role="button">
          <Icon
            name={IconName.Close}
            className={styles.icon}
            large
            color={IconColor.Light}
          />
        </div>
      )}
    </div>
  );
};

export default NoticeBanner;



// WEBPACK FOOTER //
// ./app/common/components/notice-banner/notice-banner.tsx